const state = {
    users: [],
    links: {},
    page: {},
    managers: [],
    isRequesting: false,
}
export default state